import capitalize from 'lodash/capitalize'
import { getAgeFromDobWithTime } from "src/consumer/helpers/profilePageHelper"

export function preparePatientLabelFromPatientInfoObject(patientInfo, onlyName = false) {
  // item?.name
  let label = ' '
  if (!!patientInfo?.name) {
    label = label + patientInfo?.name
  }
  if (onlyName) {
    return label
  }
  if (!label.includes('(')) {
    label = label + ' ('
  }
  if (!!patientInfo?.dateOfBirth) {
    label = label + `${getAgeFromDobWithTime(patientInfo?.dateOfBirth)} Y`
  }
  if (!label.includes('(')) {
    label = label + ' ('
  } else {
    label = label + ' / '
  }
  if (!!patientInfo?.gender) {
    label = label + capitalize(patientInfo?.gender)
  }
  if (label.includes('(')) {
    label = label + ')'
  }

  return label
}
